import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User, UserState } from '../types/user';

// Helper functions for localStorage
const saveToLocalStorage = (key: string, data: any) => {
  try {
    localStorage.setItem(key, JSON.stringify(data));
  } catch (error) {
    console.error('Error saving to localStorage:', error);
  }
};

const getFromLocalStorage = (key: string) => {
  try {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  } catch (error) {
    console.error('Error reading from localStorage:', error);
    return null;
  }
};

// Load initial state from localStorage if available
const loadInitialState = (): UserState => {
  const savedUsers = getFromLocalStorage('users');
  const savedUserDetail = getFromLocalStorage('userDetail');
  
  return {
    Users: savedUsers || [],
    Userdetail: savedUserDetail || null, // Changed from [] to null since it's accessed as object
    loading: false,
    error: null,
  };
};

const initialState: UserState = loadInitialState();

const userslice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    fetchusersSuccess: (state, action: PayloadAction<User[]>) => {
      state.loading = false;
      state.Users = action.payload;
      saveToLocalStorage('users', action.payload);
    },
    fetchuserDetailSuccess: (state, action) => {
      state.loading = false;
      state.Userdetail = action.payload;
      // Save to localStorage
      saveToLocalStorage('userDetail', action.payload);
    },
    fetchusersFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearUserData: (state) => {
      state.Users = [];
      state.Userdetail = null;
      state.loading = false;
      state.error = null;
      // Clear localStorage
      localStorage.removeItem('users');
      localStorage.removeItem('userDetail');
    },

    restoreFromStorage: (state) => {
      const savedUsers = getFromLocalStorage('users');
      const savedUserDetail = getFromLocalStorage('userDetail');
      
      if (savedUsers) state.Users = savedUsers;
      if (savedUserDetail) state.Userdetail = savedUserDetail;
    }
  },
});

export const {
  setLoading,
  fetchusersSuccess,
  fetchuserDetailSuccess,
  fetchusersFailure,
  clearUserData,
  restoreFromStorage
} = userslice.actions;

export default userslice.reducer;